/**
 * The body field carrying the Turnstile token. The backend's
 * TurnstileVerifiedSerializerMixin and require_turnstile (shared/turnstile.py)
 * read this name, not Cloudflare's `cf-turnstile-response`.
 */
export const TURNSTILE_FIELD = 'captcha_token'

/**
 * The header carrying the Turnstile token on GET requests, which have no body.
 * Django exposes it to the backend as `HTTP_CAPTCHA_TOKEN`.
 */
export const TURNSTILE_HEADER = 'Captcha-Token'

/** The Turnstile challenge itself failed; the request was never sent. */
export class ChallengeFailedError extends Error {
  constructor(cause: unknown) {
    super(cause instanceof Error ? cause.message : 'Turnstile challenge failed')
    this.name = 'ChallengeFailedError'
  }
}

/** Resolves a fresh token, or null when the challenge is not configured. */
export type GetTurnstileToken = () => Promise<string | null>

/** Runs `getToken`, turning any failure into a ChallengeFailedError. */
export const takeChallengeToken = async (getToken: GetTurnstileToken) => {
  try {
    return await getToken()
  } catch (error) {
    throw new ChallengeFailedError(error)
  }
}
